import { SolveWidgetProduct } from 'src/types/types';
import { formatProductLabel } from 'src/utils/formatProductChannels';

interface AbTestChannelOption {
  /** Feature flag required for this channel, or null if always available */
  featureFlag: string | null;
  /** Display label derived from formatProductLabel */
  label: string;
  /** SolveWidgetProduct value stored in the config */
  product: SolveWidgetProduct;
}

/**
 * Channel options available for A/B test configuration.
 * Email is excluded as A/B tests are not supported for email.
 */
const AB_TEST_CHANNEL_PRODUCTS: {
  featureFlag: string | null;
  product: SolveWidgetProduct;
}[] = [
  { featureFlag: null, product: 'workflow_builder' },
  { featureFlag: 'solve_api', product: 'api' },
  { featureFlag: 'solve_slack', product: 'slack' },
  { featureFlag: 'solve_voice', product: 'voice' },
];

export const AB_TEST_CHANNEL_OPTIONS: AbTestChannelOption[] =
  AB_TEST_CHANNEL_PRODUCTS.map(({ featureFlag, product }) => ({
    featureFlag,
    label: formatProductLabel(product),
    product,
  }));

/**
 * Returns channel options filtered by enabled feature flags,
 * formatted for SelectDropdown.
 */
export const getEnabledChannelDropdownOptions = (
  featureFlags: string[],
): { label: string; value: string }[] =>
  AB_TEST_CHANNEL_OPTIONS.filter(
    option =>
      option.featureFlag === null || featureFlags.includes(option.featureFlag),
  ).map(option => ({
    label: option.label,
    value: option.product,
  }));
